import { call, put, takeEvery } from 'redux-saga/effects'
import {
  GET_HOLIDAYS,
  ADD_HOLIDAY,
  UPDATE_HOLIDAY,
  DELETE_HOLIDAY,
} from './actionTypes'
import {
  getHolidaysSuccess,
  getHolidaysFail,
  addHolidaySuccess,
  addHolidayFail,
  updateHolidaySuccess,
  updateHolidayFail,
  deleteHolidaySuccess,
  deleteHolidayFail,
  setHolidayFieldErrors,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'

// API calls
const fetchHolidaysApi = () => axiosInstance.get('', { params: { sp: 'usp_GetAllHolidays' } })
const addHolidayApi = (holiday) => axiosInstance.post('', holiday)
const updateHolidayApi = (holiday) => axiosInstance.post('', holiday)
const deleteHolidayApi = (id) => axiosInstance.post('', { sp: 'usp_DeleteHoliday', holidayId: id })

// Sagas
function* getHolidaysSaga() {
  try {
    const { data } = yield call(fetchHolidaysApi)
    yield put(getHolidaysSuccess(data))
  } catch (error) {
    yield put(getHolidaysFail(error.response?.data || error.message))
  }
}

function* addHolidaySaga(action) {
  try {
    const { data } = yield call(addHolidayApi, action.payload)
    yield put(addHolidaySuccess(data))
    toast.success('Holiday added successfully!')
    yield put({ type: GET_HOLIDAYS })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setHolidayFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(addHolidayFail(error.response?.data || error.message))
    }
  }
}

function* updateHolidaySaga(action) {
  try {
    const { data } = yield call(updateHolidayApi, action.payload)
    yield put(updateHolidaySuccess(data))
    toast.success('Holiday updated successfully!')
    yield put({ type: GET_HOLIDAYS })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setHolidayFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(updateHolidayFail(error.response?.data || error.message))
    }
  }
}

function* deleteHolidaySaga(action) {
  try {
    yield call(deleteHolidayApi, action.payload)
    yield put(deleteHolidaySuccess(action.payload))
    toast.success('Holiday deleted successfully!')
    yield put({ type: GET_HOLIDAYS })
  } catch (error) {
    yield put(deleteHolidayFail(error.response?.data || error.message))
  }
}

// Watcher saga
function* holidaySaga() {
  yield takeEvery(GET_HOLIDAYS, getHolidaysSaga)
  yield takeEvery(ADD_HOLIDAY, addHolidaySaga)
  yield takeEvery(UPDATE_HOLIDAY, updateHolidaySaga)
  yield takeEvery(DELETE_HOLIDAY, deleteHolidaySaga)
}

export default holidaySaga
